var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"headline headline_2"},[_vm._v("Ihr Dashboard")]),_vm._v(" "),_c('section',[_c('notifications',{attrs:{"max":3}}),_vm._v(" "),_c('reseller')],1),_vm._v(" "),_c('section',[_c('products')],1),_vm._v(" "),_c('section',[_c('faq')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }